import React from 'react'
import { PaymentProofUploadCard } from '@/components/app/payments/PaymentProofUploadCard'
import { useAuth } from '@/contexts/AuthContext'

const LearnerPaymentsPage: React.FC = () => {
  const { user } = useAuth()

  return (
    <div className="space-y-6">
      <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
        <h1 className="text-2xl font-bold text-gray-900">Application Payments</h1>
        <p className="mt-2 text-sm text-gray-600">
          Upload payment receipts, track verification status, and stay in sync with the
          admissions team.
          <br />Once a payment is confirmed, your application balance updates
          automatically.
        </p>
      </div>

      <PaymentProofUploadCard applicationId={user?.applicationId ?? null} />
    </div>
  )
}

export default LearnerPaymentsPage
